import { render, staticRenderFns } from "./UnreadMessagesComponent.vue?vue&type=template&id=9dc3be12&"
import script from "./UnreadMessagesComponent.vue?vue&type=script&lang=js&"
export * from "./UnreadMessagesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports